import React from 'react';
import AOS from 'aos';
import AnimatedLogo from '../AnimatedLogo';
import banner from '../../assets/images/banner.png';
import 'aos/dist/aos.css';
import './style.scss';
import { useHistory } from 'react-router-dom';

AOS.init();
const HomeHeader = () => {
  const history = useHistory();
  return (
    <div className="home-banner">
      <img className="home-banner__img" src={banner} alt="home banner" />
      <AnimatedLogo />
      <h2 data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200" className="home-banner__title">
        هفسین
      </h2>
      <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500" className="home-banner__description">
        جایی که همه آماده کمک اند !
      </p>
      <a href="https://idpay.ir/7hafcn" target="_blank">
        <button className="home-banner__start-btn">
          کمک مالی <span className="home-banner__start-btn-highlight">سریع...</span>
        </button>
      </a>
    </div>
  );
};

export default HomeHeader;
